import styles from "./RenewalModal.module.scss";
import close from "../../../assets/icons/close.svg";
import Button from "../../button/Button";
import { useTranslation } from "react-i18next";
import { useUpdateSubscriptionMutation } from "../../../store/services/auth-api";
import { useState } from "react";
import { subscriptionData } from "../../../types/details-api-types";
import { formatPriceWithCurrency } from "../../../utils";

interface RenewalModalProps {
  setIsModalPauseConfirmVisible: (arg: boolean) => void;
  setIsModalProcessingVisible: (arg: boolean) => void;
  setIsModalSuccessfullyVisible: (arg: boolean) => void;
  data: subscriptionData;
}

const RenewalModal: React.FC<RenewalModalProps> = ({
  setIsModalPauseConfirmVisible,
  setIsModalProcessingVisible,
  setIsModalSuccessfullyVisible,
  data,
}) => {
  const [isLoader, setIsLoader] = useState(false);

  const [updateSubscription] = useUpdateSubscriptionMutation();

  const showProcessingModal = async () => {
    setIsModalPauseConfirmVisible(false);
    setIsModalProcessingVisible(true);
    setIsLoader(true);
    await updateSubscription({ subscription_id: data.subscription_id, status: false })
      .unwrap()
      .then((payload) => {
        console.info(payload);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setTimeout(() => {
          setIsLoader(false);
          setIsModalProcessingVisible(false);
          setIsModalSuccessfullyVisible(true);
        }, 3333);
      });
  };

  const { t } = useTranslation();
  return (
    <div className={styles.root}>
      <div className={styles.root_header}>
        <p className={styles.root_header_title}>{t("Ready to Reactivate Your Subscription")}</p>
        <div className={styles.root_header_imgBlock}>
          <img
            className={styles.root_header_img}
            src={close}
            alt="close"
            onClick={() => setIsModalPauseConfirmVisible(false)}
          />
        </div>
      </div>
      <p className={styles.root_subtitle}>
        {t(
          "Great news! By reactivating your subscription, you'll resume automatic renewals and continue enjoying all the amazing Fortect features."
        )}
      </p>
      <p className={styles.root_message}>
        {t("Your next renewal will be on")}{" "}
        <span className={styles.root_message_data}>{new Date(data.next_payment).toLocaleDateString()}</span> {t("for")}{" "}
        <span className={styles.root_message_data}>
          {formatPriceWithCurrency(data.renewalPrice, data.renewalPriceCurrency!)}
        </span>
        .
      </p>
      <div className={styles.root_button}>
        <Button
          onClick={showProcessingModal}
          text={t("Confirm Reactivation")}
          classNames={styles.root_btn}
          isLoader={isLoader}
        />
      </div>
    </div>
  );
};

export default RenewalModal;
